import { render, staticRenderFns } from "./CandleSad.vue?vue&type=template&id=fc4434c2&scoped=true"
var script = {}
import style0 from "./CandleSad.vue?vue&type=style&index=0&id=fc4434c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4434c2",
  null
  
)

export default component.exports